import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email, phone, linkedinUrl, handshakeUrl } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }

  .direct-contact {
    margin-top: 40px;
    color: var(--light-slate);
    font-size: var(--fz-sm);
    line-height: 2;

    a {
      color: var(--green);
    }
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, [prefersReducedMotion]);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What’s Next?</h2>

      <h2 className="title">Get In Touch</h2>

      <p>
        I’m looking for an <strong>internship in finance or risk management</strong> — somewhere
        I can put what I’m studying to work and learn from people who have been doing it longer.
        If that’s your team, or you just want to say hello, my inbox is open and I answer it.
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        Say hello
      </a>

      <div className="direct-contact">
        <div>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
        {phone && (
          <div>
            <a href={`tel:${phone.replace(/[^+\d]/g, '')}`}>{phone}</a>
          </div>
        )}
        <div>Iowa City, Iowa</div>
        {linkedinUrl && (
          <div>
            <a href={linkedinUrl} target="_blank" rel="noreferrer">
              LinkedIn
            </a>
          </div>
        )}
        {handshakeUrl && (
          <div>
            <a href={handshakeUrl} target="_blank" rel="noreferrer">
              Handshake
            </a>
          </div>
        )}
      </div>
    </StyledContactSection>
  );
};

export default Contact;
